import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import { withNamespaces, WithNamespaces } from 'react-i18next';

const Exit: React.FunctionComponent<WithNamespaces> = ({ t }) => {
    return (
        <IconButton aria-label="Motorway">
            <SvgIcon viewBox="-4 -5 39 39" preserveAspectRatio="xMinYMin meet">
                <title>{t('icons.motorway')}</title>
                <defs>
                    <polygon id="path-1" points="11.1666667 0 5.66666667 0 0.166666667 27 11.1666667 27"></polygon>
                    <polygon id="path-3" points="0 5.33333333 0 0.333333333 32 0.333333333 32 6.33333333 29 6.33333333 29 3.80266667 3 3.80266667 3 6.33333333 0 6.33333333"></polygon>
                    <polygon id="path-5" points="0.166666667 0 5.66666667 0 11.1666667 27 0.166666667 27"></polygon>
                </defs>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="2.0.4-Full-Screen-MOTORWAY" transform="translate(-270.000000, -23.000000)">
                        <g id="Icon_Motorway" transform="translate(270.000000, 23.000000)">
                            <g id="Clipped" transform="translate(3.333333, 0.333333)">
                                <mask id="mask-2" fill="white">
                                    <use href="#path-1"></use>
                                </mask>
                                <g id="Path"></g>
                                <path d="M16.1666667,-5 L16.1666667,32 L-4.83333333,32 L-4.83333333,-5 L16.1666667,-5 Z M12.8413333,12.472 L2.53066667,12.472 L2.53066667,15 L12.8413333,15 L12.8413333,12.472 Z" id="Shape" fill="#FFFFFF" mask="url(#mask-2)"></path>
                            </g>
                            <g id="Clipped" transform="translate(0.000000, 9.000000)">
                                <mask id="mask-4" fill="white">
                                    <use href="#path-3"></use>
                                </mask>
                                <g id="Path"></g>
                                <rect id="Rectangle" fill="#FFFFFF" mask="url(#mask-4)" x="-5" y="-4.66666667" width="42" height="16"></rect>
                            </g>
                            <g id="Clipped" transform="translate(17.333333, 0.333333)">
                                <mask id="mask-6" fill="white">
                                    <use href="#path-5"></use>
                                </mask>
                                <g id="Path"></g>
                                <path d="M16.1666667,-5 L16.1666667,32 L-4.83333333,32 L-4.83333333,-5 L16.1666667,-5 Z M8.84133333,12.472 L-1.46933333,12.472 L-1.46933333,15 L8.84133333,15 L8.84133333,12.472 Z" id="Shape" fill="#FFFFFF" mask="url(#mask-6)"></path>
                            </g>
                        </g>
                    </g>
                </g >
            </SvgIcon >
        </IconButton >
    );
}

export default withNamespaces()(Exit);